import { React } from "aaa";
import { NativeTextField } from "components/common/NativeTextField";

/**
 * Material UI textfield that shrinks font if too big (similar to iOS UILabel).
 * Needs value property for checking.
 */
export class DynamicFontTextfield extends React.Component<any, {}> {
    static counter = 0;

    canvas?: HTMLCanvasElement;
    inputName: string;

    constructor(props: any) {
        super(props);

        // Assign name to find DOM element later
        if (props.name) {
            this.inputName = props.name;
        } else {
            this.inputName = "dynamicFontInput" + DynamicFontTextfield.counter;
            ++DynamicFontTextfield.counter;
        }
    }

    /**
     * Measures a text in pixels
     * @param txt 
     * @param font (e.g. "30px Inter Light")
     */
    getTextWidth(txt: string, font: string): number {
        if (!this.canvas) {
            this.canvas = document.createElement("canvas");
        }

        const context = this.canvas.getContext("2d");
        if (context) {
            context.font = font;
            return context.measureText(txt).width;
        }

        return -1;
    }

    render() {
        let props: any = { ...this.props };
        props.name = this.inputName;
        if (props.value
            && props.inputStyle
        ) {
            const fontFamily = props.inputStyle.fontFamily || "Inter Light";
            let fontSize = props.inputStyle.fontSize || 30;

            const input = document.getElementsByName(this.inputName);
            if (input.length > 0) {
                // Do the actual resizing
                const width = input[0].offsetWidth;
                while (this.getTextWidth(props.value, `${fontSize}px ${fontFamily}`) > width) {
                    --fontSize;
                }
            }

            // Set calculated font size
            props.inputStyle.fontSize = fontSize;
        }

        return (
            <NativeTextField
                {...props}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/util/DynamicFontTextfield.tsx